<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height="calc(100vh - 300px)"   :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
                    <template v-slot:item="{ item, index }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ total_rows - index }}</td>
                            <td>{{ item.TransactionCode }}</td>
                            <td>
                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, UID: item.UID})">
                                    <div>
                                        {{ item.Username || '-' }}
                                    </div>
                                    <template v-slot:input>
                                        <v-autocomplete 
                                            v-model="item.UID" 
                                            :items="customers" 
                                            item-text="CustomerCode" 
                                            item-value="ID" 
                                            label="Khách hàng" 
                                            single-line 
                                            autofocus
                                        ></v-autocomplete>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right">
                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                    <div>
                                        {{ item.Weight | currency('', 2) }}
                                    </div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-if="isDepositOrder">{{ item.StoreVNImportDate | display_date }}</td>
                            <td v-else>{{ item.StoreDestImportDate | display_date }}</td>
                            <td class="text-right">
                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, FeeShipVND: item.FeeShipVND})">
                                    <div>
                                        {{ item.FeeShipVND | currency }}
                                    </div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.FeeShipVND" type="number" step="1" label="Phí khác" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-tooltip top max-width="250">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.StoreCNNote }}</span>
                                    </template>
                                    <span>{{ item.StoreCNNote }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-center">
                                <v-icon medium class="ma-1" color="red darken-2" @click="deleteItem(item)">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-dialog
            v-model="showDialogTrancode"
            :fullscreen="isMobile"
            :max-width="isMobile ? undefined : 1180"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="oee-theme">
                    <v-btn icon dark @click="showDialogTrancode=false">
                        <v-icon>fa-times</v-icon>
                    </v-btn>
                    <v-toolbar-title>Nhập kho VN ngày {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip small outlined color="white" v-if="popup_items && popup_items.length">
                        Đã nhập: {{ popup_items.length }} bill
                    </v-chip>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <v-container fluid class="pa-0">
                        <v-row>
                            <v-col cols="12" md="5" lg="4">
                            <v-card outlined class="pa-4">
                                <v-card-title class="subtitle-1 font-weight-bold px-0 pt-0 pb-3">
                                    Thông tin nhập kho
                                </v-card-title>
                                <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded" v-if="showDialogTrancode && isMobile && newTransaction.TransactionCode == ''"></StreamBarcodeReader>
                                <v-form ref="importForm">
                                    <v-row>
                                        <v-col cols="12" class="py-0">
                                            <v-checkbox
                                                v-model="useBarcodeScanner"
                                                label="Sử dụng máy đọc mã vạch"
                                                dense
                                                hide-details
                                                class="mt-0"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-autocomplete
                                                v-model="newTransaction.UID"
                                                :items="customers"
                                                item-text="CustomerCode"
                                                item-value="ID"
                                                label="Khách hàng"
                                                dense
                                                clearable
                                                ref="popup_customer"
                                                @keyup.enter="focusTrancode"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-text-field
                                                class="input-group--focused"
                                                ref="popup_trancode"
                                                dense
                                                label="Mã bill"
                                                hint="Quét mã hoặc nhập mã bill rồi Enter"
                                                persistent-hint
                                                v-model="newTransaction.TransactionCode"
                                                @keyup.enter="saveNewTrancode(false)"
                                                @input="onTransactionCodeChange"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <h-currency-input
                                                class="input-group--focused"
                                                v-model="newTransaction.Weight"
                                                label="Cân nặng (kg)"
                                                :decimal="1"
                                                @press_enter="focusNext"
                                            ></h-currency-input>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <h-currency-input
                                                class="input-group--focused"
                                                v-model="newTransaction.FeeShipVND"
                                                label="Phí khác"
                                                :decimal="0"
                                                @press_enter="focusNext"
                                            ></h-currency-input>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-textarea
                                                class="input-group--focused"
                                                v-model="newTransaction.StoreCNNote"
                                                label="Ghi chú"
                                                auto-grow
                                                dense
                                                rows="2"
                                                @keydown.enter.exact.prevent="saveNewTrancode"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-card-actions class="px-0 pb-0">
                                    <v-spacer></v-spacer>
                                    <v-btn large @click="saveNewTrancode">
                                        <v-icon left>fa-save</v-icon>
                                        Nhập kho
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                            </v-col>
                            <v-col cols="12" md="7" lg="8">
                            <v-card outlined>
                                <v-card-title class="subtitle-1 font-weight-bold py-3">Danh sách vừa nhập</v-card-title>
                                <v-data-table
                                    :headers="popup_headers"
                                    :items="popup_items"
                                    hide-default-footer
                                    disable-pagination
                                    :loading="loading"
                                    :mobile-breakpoint="100"
                                >
                                    <template v-slot:item="{ item, index }">
                                        <tr :class="{'amber lighten-5': !item.Weight || parseFloat(item.Weight) == 0}">
                                            <td>{{ popup_items.length - index }}</td>
                                            <td>{{ item.TransactionCode }}</td>
                                            <td>
                                                <v-autocomplete 
                                                    v-model="item.UID" 
                                                    :items="customers" 
                                                    item-text="CustomerCode" 
                                                    item-value="ID" 
                                                    label="Khách hàng" 
                                                    dense
                                                    hide-details
                                                    single-line 
                                                    :ref="'customerSelect_' + item.ID"
                                                    @change="saveItem({ID: item.ID, UID: item.UID})"
                                                    @keyup.enter="focusTrancode"
                                                ></v-autocomplete>
                                            </td>
                                            <td class="text-right">
                                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                                    <div :class="{'red--text font-weight-bold': !item.Weight || parseFloat(item.Weight) == 0}">
                                                        {{ item.Weight | currency('', 2) }}
                                                        <v-icon small color="error" v-if="!item.Weight || parseFloat(item.Weight) == 0" class="ml-1">fa-exclamation-triangle</v-icon>
                                                    </div>
                                                    <template v-slot:input>
                                                        <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" single-line autofocus></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="text-right">
                                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, FeeShipVND: item.FeeShipVND})">
                                                    <div>{{ item.FeeShipVND | currency }}</div>
                                                    <template v-slot:input>
                                                        <v-text-field v-model="item.FeeShipVND" type="number" step="1" label="Phí khác" single-line autofocus></v-text-field>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="truncate">
                                                <v-edit-dialog large lazy persistent @save="saveItem({ID: item.ID, StoreCNNote: item.StoreCNNote})">
                                                    <div>{{ item.StoreCNNote || '-' }}</div>
                                                    <template v-slot:input>
                                                        <v-textarea v-model="item.StoreCNNote" label="Ghi chú" auto-grow rows="2" autofocus></v-textarea>
                                                    </template>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="text-center">
                                                <v-btn icon small color="error" @click="deleteItem(item)" title="Xóa">
                                                    <v-icon small>fa-trash</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="appLoading" z-index="999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-layout>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import {isMobileAgent, focusNextElement, getCurrentTime} from "@/commons/utils";
import Filtering from "@/components/Filtering";
import { StreamBarcodeReader } from "vue-barcode-reader";
import _, { sortBy } from "lodash";

export default {
    components: {
        StreamBarcodeReader,
        "hpo-filter": Filtering
    },
    data() {
        return {
            isDepositOrder: configs.SYSTEM_TYPE != 'order',
            uniqueId: Date.now().toString(36) + Math.random().toString(36).substring(2),
            currentTime: getCurrentTime(),
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            pagination: {  ...configs.PAGINATION,  sortBy: ['StoreVNImportDate']  },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "storeimporttransaction_list",
            filterConditions: [],
            quickFilterConditions: [],
            appLoading: false,
            showDialogTrancode: false,
            useBarcodeScanner: true,
            focusNext: null,
            pendingFocusCustomerNewRow: false,
            newTransaction: {
                UID: null,
                TransactionCode: '',
                Status: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
                Weight: 0,
                FeeShipVND: 0,
                StoreCNNote: '',
            },
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        showDialogTrancode() {
            if (this.showDialogTrancode) {
                this.uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
                this.$store.commit("orderTransaction/setListImportVN", { data: []});
                this.useBarcodeScanner = true;
                this.pendingFocusCustomerNewRow = false;
                this.resetNewTransaction();
                this.focusFirstInput();
            } else {
                this.filter_data();
            }
        },
        popup_items: {
            handler(newVal) {
                if (this.pendingFocusCustomerNewRow && newVal && newVal.length > 0) {
                    this.pendingFocusCustomerNewRow = false;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.focusNewRowCustomer();
                        }, 200);
                    });
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
            customers: state => state.customer.master.data,
            configuration: state => state.configuration.selected,
        }),
        popup_items() {
            return this.$store.state.orderTransaction.listImportVN.data || [];
        },
        isMobile: isMobileAgent,
        headers() {
            return [
                {
                    text: "STT",
                    value: "index"
                },
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Nhập kho VN",
                    value: configs.SYSTEM_TYPE == "order" ? "StoreDestImportDate" : "StoreVNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Phí khác",
                    value: "FeeShipVND",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "StoreCNNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: ""
                }
                ];
        },
        popup_headers() {
            return [
                {
                    text: "STT",
                    value: "index",
                    sortable: false
                },
                {
                    text: "Mã bill",
                    value: "TransactionCode",
                    filterable: true,
                    sortable: false,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    sortable: false,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    sortable: false,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí khác",
                    value: "FeeShipVND",
                    filterable: true,
                    sortable: false,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "StoreCNNote",
                    filterable: true,
                    sortable: false,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "action",
                    sortable: false
                }
            ];
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        storeVNRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
        filter_param() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            param.filter.push({
                column: "Status",
                value: configs.SYSTEM_TYPE == 'order' ? [configs.PACKAGE_STATUS_ENUM.DA_NHAP_KHO_PHAT, configs.PACKAGE_STATUS_ENUM.DA_VE_VN] : [configs.PACKAGE_STATUS_ENUM.DA_VE_VN],
                condition: "in"
            });
            param.filter.push({
                column: "BigPackageID",
                value: 0,
                condition: "equal"
            });
            
            return param;
        },
        popup_filter() {
            return [
                {
                    column: "GUID",
                    value: this.uniqueId,
                    condition: "s_equal"
                },
                {
                    column: "Status",
                    value: configs.SYSTEM_TYPE == 'order' ? [configs.PACKAGE_STATUS_ENUM.DA_NHAP_KHO_PHAT, configs.PACKAGE_STATUS_ENUM.DA_VE_VN] : [configs.PACKAGE_STATUS_ENUM.DA_VE_VN],
                    condition: "in"
                }
            ]
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "CustomerCode"]
            });
        },
        saveItem:_.debounce(
        function(item) {
            var data = {
               ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            data.Status = configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        // Only admin can view table, staff need search by code
        filter_data: function () {            
            if (this.showDialogTrancode) {
                this.getListData();
            } else {
                this.$store.dispatch("orderTransaction/getList", this.filter_param);
            }
            this.appLoading = false;
        },
        showTransactionDialog() {
            this.showDialogTrancode = true;
        },
        focusTrancode() {
            this.$nextTick(() => {
                if (this.$refs.popup_trancode) {
                    this.$refs.popup_trancode.focus();
                }
            });
        },
        onTransactionCodeChange: _.debounce(
            function() {
                if (this.useBarcodeScanner) {
                    this.saveNewTrancode(false);
                }
            },
            100,
            { leading: false, trailing: true }
        ),
        focusFirstInput() {
            this.$nextTick(() => {
                this.$refs.popup_trancode.focus();
            });
        },
        saveNewTrancode(isSaveWeight = true) {
            if (this.onTransactionCodeChange && typeof this.onTransactionCodeChange.cancel === 'function') {
                this.onTransactionCodeChange.cancel();
            }
            const code = this.newTransaction.TransactionCode ? this.newTransaction.TransactionCode.trim() : '';
            if(code == '') {
                this.focusFirstInput();
                return;
            }
            const isUidEmpty = !this.newTransaction.UID;
            let payload = {
                ...this.newTransaction,
                TransactionCode: code,
                GUID: this.uniqueId,
                BigPackageId: 0
            }
            if (!isSaveWeight) {
                delete payload.Weight;
                delete payload.FeeShipVND;
            }
            this.$store.dispatch("bigPackage/addNewTrancode", {'data': payload});
            this.resetNewTransaction();
            if (isUidEmpty) {
                this.pendingFocusCustomerNewRow = true;
            } else {
                this.focusFirstInput();
            }
        },
        focusNewRowCustomer() {
            this.$nextTick(() => {
                const topItem = this.popup_items && this.popup_items[0];
                if (topItem && topItem.ID) {
                    const refObj = this.$refs['customerSelect_' + topItem.ID];
                    const comp = Array.isArray(refObj) ? refObj[0] : refObj;
                    if (comp && typeof comp.focus === 'function') {
                        comp.focus();
                        return;
                    }
                }
                const firstRowInput = document.querySelector('.v-dialog--active .v-data-table tbody tr:first-child input') ||
                                      (this.$el && this.$el.querySelector('.v-data-table tbody tr:first-child input'));
                if (firstRowInput) {
                    firstRowInput.focus();
                }
            });
        },
        resetNewTransaction() {
            const currentUID = this.newTransaction.UID;
            this.newTransaction = {
                UID: currentUID,
                Status: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
                TransactionCode: '',
                Weight: 0,
                FeeShipVND: 0,
                StoreCNNote: '',
            };
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        getListData() {
            var param = {
                pagination: {...this.pagination, sortBy: ['StoreVNImportDate'], itemsPerPage: 10000},
                filter: this.popup_filter,
                quickFilter: []
            };
            this.$store.dispatch("orderTransaction/getListImportVN", param);
        },
        exportExcel() {
            this.$store.dispatch("orderTransaction/export", this.filter_param);
        },
        deleteItem(item) {
            window.getApp.$emit('REQUEST_DELETE_DATA', item.ID);
        },
        onDecode(data) {
            this.newTransaction.TransactionCode = data;
        },
        onLoaded() {}
    },
    created() {
        this.focusNext = focusNextElement;
        this.getCustomerList();
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.showTransactionDialog);
        this.$root.$on("REQUEST_OTHER_ACTION", this.exportExcel);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orderTransaction/postOrderTransaction", {
                'ID': id,
                'Type': "transaction",
                'ModifiedBy': this.$store.state.authentication.user.username,
                'Status': configs.PACKAGE_STATUS_ENUM.DANG_VE_VN,
            });
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA", this.showTransactionDialog);
        this.$root.$off("REQUEST_OTHER_ACTION", this.exportExcel);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
